import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import './styles/global.css'; 
import { RefreshComp } from './utils/refreshContext'; 
// import LoginPage from './pages/login';
// import SignupPage from './pages/signup';
import NewJobCreation from './components/provider/new_job_creation'; // Import the Create New Job component
import Dashboard from './pages/provider/dashboard';
import DashboardSeeker from './pages/seeker/dashboard'; // Import the Dashboard
import Dashboardcomponent from './components/provider/dashboard';
import UserTypeSelection from './pages/UserTypeSelection';
import LoginWithSignup from './pages/loginwithsignup';
import SearchBar from './components/provider/header'; // Import the SearchBar component
import JobList from './components/provider/JobList'; // Import the JobList component 
import VerifyEmail from './pages/verifyEmail';
import DashBoardUi from './pages/provider/dashboardUi';
import JobManage from './pages/provider/jobManage';
import HomePage from './pages/provider/HomePage';
import ProviderProfile from  './pages/provider/MyProfile';
import DashboardWorking from './pages/provider/dashboardWorking';
import Sidebar from './components/global/sideBar';
import CreateJob from './pages/provider/createJob';
import AnalyticCard from './components/provider/AnalyticCard';
import PostJob from './components/provider/postJob';
import ProviderHome from './pages/provider/providerHome';
import JobListTable from './components/provider/jobListTable';
import Pagination from './components/global/pagination';

import CheckingAkshay from './pages/provider/checkingAkshay';
import Settings from './pages/provider/settings'
import DeleteConfirmationDialog from './components/global/deleteConfirmation';
//import LoginSignInPage from './pages/LoginSignInPage';
import ProviderHistoryTable from './components/provider/history';
import JobManagementPage from './pages/provider/jobManagement';
import PrivacyPolicy from './components/provider/privacyPolicy';
import ViewJob from './components/provider/viewJob';
import ApplicantProfile from './components/provider/applicantProfile';
import JobListHome from './components/seeker/JobListHome';
import SeekerHome from './pages/seeker/seekerHome';
import SearchJob from './components/seeker/SearchJob';
import ProfileOverview from './components/seeker/profileOverview';
import MyCalender from './components/seeker/myCalendar';
import UserRedirection from './utils/userRedirection';
import AboutCompany from './components/seeker/aboutCompany';
import AdminHome from './pages/admin/adminHome';
import JobApprovedList from './components/seeker/jobApprovedList';
import Chat from './components/global/chat';
import CertificateManuelVerification from './components/admin/CertificateManuelVerificationComponent';
import CertificateSpecializationRelation from './components/admin/CertificateSpecializationRelation';
import PasswordResetPage from './pages/passwordResetPage';
import InvoiceDetails from './components/global/invoiceDetails';
import Payments from './components/seeker/payments';

import GuiTest from './pages/seeker/guiTest';
import PaymentComponent from './components/provider/payment';
import TestRevolutAPI from './components/TestRevolutAPI';

function App() {
  return (
    <Router>
      <div className="App">
        <RefreshComp> {/* Wrap the components with JobProvider */}

          <Routes>
            <Route path="/" element={<LoginWithSignup />} />
            <Route path="/checkingAkshay" element={<CheckingAkshay />} />
            <Route path="/create-job" element={<NewJobCreation />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/seeker/dashboard" element={<DashboardSeeker />} />
            <Route path="/user-type-selection" element={<UserTypeSelection />} />
            <Route path="/header" element={<SearchBar onSearch={() => {}} />} />
            <Route path="/job-list" element={<JobList />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/dashboardcomponent" element={<Dashboardcomponent />} />
            <Route path="/dashboardUi" element={<DashBoardUi />} />
            <Route path="/job-manage" element={<JobManage />} />
            <Route path="/homepage" element={<HomePage />} />
            <Route path="/providermyprofile" element={<ProviderProfile />} />
            <Route path="/dashboardworking" element={<DashboardWorking />} />
            <Route path="/sidebar" element={<Sidebar />} />
            <Route path="/createJob" element={<CreateJob />} />
            <Route path="/analytic-card" element={<AnalyticCard />} />
            <Route path="/post-job" element={<PostJob />} />
            <Route path="/provider-home" element={<ProviderHome />} />
            <Route path="/job-list-table" element={<JobListTable />} />
            <Route path="/pagination" element={<Pagination />} />
            <Route path="/provider-settings" element={<Settings />} />
            <Route path="/history" element={<ProviderHistoryTable />} />
            <Route path="/job-management" element={<JobManagementPage />} />
            <Route path="/delete-confirmation" element={<DeleteConfirmationDialog />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/view-job" element={<ViewJob />} />
            <Route path="/applicant-profile" element={<ApplicantProfile />} />
            <Route path="/job-list-home" element={<JobListHome />} />
            <Route path="/seeker-home" element={<SeekerHome />} />
            <Route path="/search-job" element={<SearchJob />} />
            <Route path="/profile-overview" element={<ProfileOverview />} />
            <Route path="/my-calender" element={<MyCalender />} />
            <Route path="/gui-test" element={<GuiTest />} />
            <Route path="/user-redirection" element={<UserRedirection />} />
            <Route path="/about-company" element={<AboutCompany />} />
            <Route path="/admin" element={<AdminHome />} />
            <Route path="/job-approved-list" element={<JobApprovedList />} />
            {/*<Route path="/chat" element={<Chat />} />*/}
            <Route path="/certificate-manuel-verification" element={<CertificateManuelVerification />} />
            <Route path="/certificate-specialization-relation" element={<CertificateSpecializationRelation />} />
            <Route path="/password-reset" element={<PasswordResetPage />} />
            <Route path="/invoice-details" element={<InvoiceDetails />} />
            <Route path="/payments" element={<Payments />} />     //seeker
            <Route path="/payment" element={<PaymentComponent />} />  //provider
            <Route path="/test-revolut-api" element={<TestRevolutAPI />} />
          </Routes>
        </RefreshComp>
      </div>
    </Router>
  );
}

export default App;
// function App() {
//   return (
//     <Router>
//       <div className="App">
//       <JobProvider>
//         <Routes>
//           <Route path="/" element={<LoginWithSignup />} />
//           <Route path="/checkingAkshay" element={<CheckingAkshay />} />
//           {/* <Route path="/loginWithSignup" element={<LoginWithSignup />} /> */}
//           {/* <Route path="/signup" element={<SignupPage />} /> */}
//           <Route path="/create-job" element={<NewJobCreation />} /> {/* New Route for Create Job */}
//           <Route path="/dashboard" element={<Dashboard />} /> {/* Add Dashboard route */}
//           <Route path="/user-type-selection" element={<UserTypeSelection />} /> {/* Add User Type Selection route */}
//           {/* <Route path="/loginwithsignup" element={<LoginWithSignup />} /> Add Login With Signup route */}
//           <Route path="/header" element={<SearchBar onSearch={() => {}} />} /> {/* Add SearchBar route */}
//           <Route path="/job-list" element={<JobList />} /> {/* Add JobList route */}
//           <Route path="/verify-email" element={<VerifyEmail />} /> {/* Add Verify Email route */}
//           <Route path="/dashboardcomponent" element={<Dashboardcomponent />} /> {/* Add Dashboard component route */}
//           <Route path="/dashboardUi"element = {<DashBoardUi/>}/>
//           <Route path="/job-manage" element={<JobManage />} /> {/* Add Job Manage route */}
//           <Route path="/homepage" element={<HomePage />} /> Add Home Page route
//           <Route path="/providermyprofile" element={<ProviderProfile />} /> 
//           <Route path="/dashboardworking" element={<DashboardWorking />} /> 
//           <Route path="/sidebar" element={<Sidebar />} />
//           <Route path="/createJob" element={<CreateJob />} />
//           <Route path="/analytic-card" element={<AnalyticCard />} />
//           <Route path="/post-job" element={<PostJob />} />
//           <Route path="/provider-home" element={<ProviderHome />} />
//           <Route path="/job-list-table" element={<JobListTable />} />
//           <Route path="/pagination" element={<Pagination />} />

//           <Route path="/provider-settings" element={<Settings/>}/>
//           {/* <Route path="/checkingAkshay" element={<checkingAkshay />} /> */}

//           <Route path="/history" element={<ProviderHistoryTable />} />
//           <Route path="/job-management" element={<JobManagementPage />} />
//           <Route path="/delete-confirmation" element={<DeleteConfirmationDialog />} />
//           <Route path="/privacy-policy" element={<PrivacyPolicy />} />
//           <Route path="/view-job" element={<ViewJob />} />
//           <Route path="/applicant-profile" element={<ApplicantProfile />} />
//           {/* <Route path='/loginsigninpage' element = {<LoginSignInPage/>}/> */}
//           {/* Uncomment and add other routes as needed */}
//           {/* <Route path="/dashboard" element={<Dashboard />} /> */}
//           {/* <Route path="/home" element={<Home />} /> */}
//         </Routes>
//       </div>
//       </JobProvider>
//     </Router>
//   );
// }

// export default App;



